import React, { useState, useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import LessonDetails from "./LessonDetails";
import classes from "./EditLessonWithContent.module.css";
import { Stepper, Step } from "../../UI/Stepper";
import LessonContent from './LessonContent'
import { lessonsApi } from "../../../utils";
import ExposeNFinalLesson from "./ExposeNFinalLesson";
import { useNavigate } from "react-router-dom";
import { throwApiError } from "../../lms-shared/store/error-handling-actions";
import ReflectionQuestions from "./Reflection/ReflectionQuestions/ReflectionQuestions";
import UploadLessonPlan from "./UploadLessonPlan/UploadLessonPlan";

const EditLessonWithContent = ({ idLesson, courseName, tocName, toCParentId, studyGroupId, isProfession, prevToCId }) => {

    const texts = useSelector(state => state.translate.texts);
    const [tempSave, setTempSave] = useState();
    const [tempCMSStatus, setTempCMSStatus] = useState(true);
    const [assessments, setAssessments] = useState([]);

    const navigate = useNavigate()
    const dispatch = useDispatch()
    const homeUrl = useSelector((state) => state.application.homeUrl);

    const [data, setData] = useState({
        id: null,
        name: "",
        description: "",
        ideId: null,
        active: true,
        visible: false,
        isLocked: true
    })

    useEffect(() => {
        if (idLesson && idLesson != '0') {
            const data = {
                id: idLesson
            }
            lessonsApi.lessonsFilterPost({ lessonFilter: data }, (error, resdata, response) => {
                if (error) {
                    dispatch(throwApiError({ userMessage: texts.lessonsFilterError, error: error, statusCode: response?.statusCode, message: "lessonsFilterPost " + error.message, level: 2, component: "EditLessonWithContent", line: 39 }))
                }
                else {
                    response.body.ideId = resdata.ide.id
                    const newbody = response.body
                    if (response.body.contentData) {
                        const newAdditionalData = JSON.parse(newbody.contentData)
                        newbody.contentData = newAdditionalData
                    }
                    setData({ ...newbody });
                }
            })
        }
    }, [idLesson])

    useEffect(() => {
        if (!data?.studyGroupId) {
            setData({ ...data, studyGroupId })
        }
    }, [studyGroupId])

    const handleChangeBaseProperties = (name, description, ideId, id) => {
        setData({ ...data, name: name, description: description, ideId: ideId, id: id })
    }

    const handleChangeExposure = (visible) => {
        setData({ ...data, visible: visible })
    }

    const changeLesson = (newData) => {
        setData({ ...data, ...newData })
    }

    const onEnd = () => {
        if (isProfession)
            navigate(-1)
        else {
            if (studyGroupId)
                navigate(`${homeUrl}/courses/${studyGroupId}`)
            else
                navigate(`${homeUrl}/courses`)
        }
    }


    return (<div className={classes.NewCourse}>
        {/* <div className={classes.TempCmsData}>
            משהו זמני ל cms
            <div>{tempSave}</div>
            <div>{tempCMSStatus ? "שמור" : "לא שמור"}</div>
        </div> */}
        <Stepper onEnd={onEnd} title={!!(idLesson) ? texts.editLesson : texts.newLesson} courseName={courseName} tocName={tocName} subTitle={data.name ? data.name : texts.newLesson} canEditAll={!!(idLesson)} arrowOnClick={() => { navigate(-1) }}>
            <Step description={`${texts.details} ${texts.lesson}`} buttonText={texts.saveAndContinue}>
                <LessonDetails handleChangeBaseProperties={handleChangeBaseProperties} data={data} toCParentId={toCParentId} studyGroupId={studyGroupId} isProfession={isProfession} prevToCId={prevToCId} />
            </Step>
            {/* <Step description={texts.curriculumAffiliation} skipButton={true}><div>{texts.curriculumAffiliation}</div></Step>
            <Step description={texts.earlyKnowledge}><div>{texts.earlyKnowledge}</div></Step> */}
            <Step description={texts.createLesson} buttonText={texts.saveAndContinue}><LessonContent setTempCMSStatus={setTempCMSStatus} setTempSave={setTempSave} setLesson={changeLesson} {...data} studyGroupId={studyGroupId} data={data} assessments={assessments} setAssessments={setAssessments} /></Step>
            {/* <Step description={texts.addTask}></Step> */}
            {/* <Step description={texts.addQ}><div>{texts.addQ}</div></Step> */}
            <Step description={texts.addLessonPlan} buttonText={texts.continue}><UploadLessonPlan setLesson={changeLesson} {...data} /></Step>
            <Step description={texts.addReflection} buttonText={texts.continue}><ReflectionQuestions lessonId={data.id} studyGroupId={studyGroupId} /></Step>
            {/* <Step description={texts.exposureAndLabeling}><ExposureAndLabeling /></Step> */}
            <Step description={texts.exposeNFinalEditLesson}><ExposeNFinalLesson lessonDetails={data} handleChangeExposure={handleChangeExposure} visible={data?.visible} changeLesson={changeLesson}></ExposeNFinalLesson></Step>
        </Stepper>
    </div>)
}

export default EditLessonWithContent;